import { ElectronicsCCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const ElectronicsCCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case ElectronicsCCActionType.ElectronicsCC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default ElectronicsCCReducer
